import { render, staticRenderFns } from "./Farmer.vue?vue&type=template&id=73e4b943&"
import script from "./Farmer.vue?vue&type=script&lang=js&"
export * from "./Farmer.vue?vue&type=script&lang=js&"
import style0 from "./Farmer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports